import * as Action from "@actions/index";

const InitialState = {
  display: true,
};

export default function Footer(state = InitialState, action: any) {
  switch (action.type) {
    case Action.Ui.Footer.SHOW:
    case Action.Ui.Footer.HIDE:
      return { ...state, ...action.data };
    default:
      return state;
  }
}
